import { connect } from 'react-redux';
import { PROBE_GET_KAFKA_TOPIC_SAMPLE_REQUEST } from '../../../constants/actionTypes';
import { probeGetKafkaTopicSample, updateFormData } from '../../../actions';
import ConfigureKafka from './ConfigureKafka';

const mapStateToProps = (state, ownProps) => {
  const { paging, forms, probe, request } = state;
  const { selectedCredentialId } = ownProps;
  const { error, topics, subscriptions, samples, queues } = probe[selectedCredentialId] || {};
  const isLoadingSample = !!request[PROBE_GET_KAFKA_TOPIC_SAMPLE_REQUEST];
  const formType = forms.activeType;

  return {
    paging,
    formType,
    error,
    topics,
    subscriptions,
    queues,
    samples,
    isLoadingSample,
  };
};

export default connect(mapStateToProps, {
  probeGetKafkaTopicSample,
  updateFormData,
})(ConfigureKafka);
